<template>

  <div class='text-left mt-10'>
      
      <v-row v-if="loading">
        <v-col cols="5">
        </v-col>
        <v-col cols="2">
          <v-progress-circular
              
              size="64"
              indeterminate
              color="grey"
          ></v-progress-circular>
        </v-col>
        <v-col cols="5">
        </v-col>
      </v-row>
    <v-row class='mt-5 pb-10' v-if="!loading">
            <v-btn :color="$mainColor" label dark @click='get_excel' >
                excel: заявки 2024 по календарю
            </v-btn>
    </v-row >
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
  export default {
    data () {
      return {
        listRequestStation: [],
        loading: false,
      }

    },
     methods: {
        ...mapActions([
            'UPLOAD_LIST_TO_EXCEL'
        ]),
        ...mapMutations([
          'UPDATE_OVERLAY',
        ]),
        
        get_excel(){
            this.UPDATE_OVERLAY(true)
            const proposals = [];

            var type_id = 2024

            this.UPLOAD_LIST_TO_EXCEL({proposal_ids: proposals, type_id: type_id})
                .then((res) => {
                this.UPDATE_OVERLAY(false)
                window.open(res.url, '_blank');
                })
                .catch((e) => {
                this.UPDATE_OVERLAY(false)
                });
        },
        formate_date(str){
            var date_obj = new Date(str)
            var month = date_obj.getMonth() + 1
            var date = date_obj.getDate()

            if (month<10) month = '0' + month
            if (date<10) date = '0' + date
            return date+'/'+ month + ' ' + str.split('T')[1].split(':')[0] + ':' + str.split('T')[1].split(':')[1]
        },
     },
  }
</script>